<template>
  <div>
    <br>
    <br>
    <br>
    <br>
    <v-sheet class="d-flex flex-column justify-center align-center">

      <object v-if="isSBP()" type="image/svg+xml" data="https://sbp.nspk.ru/i/logo-black.svg">
        <!-- Your fall back here -->
        <img src="https://sbp.nspk.ru/i/logo-black.svg" />
      </object>

      <v-card-title v-if="isSBP()">Сканируйте QR код <br>в приложении Вашего банка</v-card-title>
      <v-card-title v-else>QR ссылки на оплату, наведите камеру телефона</v-card-title>

      <br>
      <v-img v-if="$route.query['url']" width="260"
             :src="'https://api.qrserver.com/v1/create-qr-code/?size=260x260&data='+$route.query['url']"></v-img>
      <v-card-title v-else class="text-red-accent-2">Нет ссылки!</v-card-title>
      <br>
      <v-btn v-if="!isSBP()" :disabled="!$route.query['url']" color="primary" :href="$route.query['url']">
        Перейти...
      </v-btn>

      <v-card-title v-if="$route.query['orderId']">Заказ #{{$route.query['orderId']}}</v-card-title>
      <v-card-title v-if="$route.query['amount']">{{$route.query['amount']}},00 руб.</v-card-title>

      <br>
      <v-btn v-if="isSBP() && !!$vuetify.display.mobile" :disabled="!$route.query['url']"  color="green"  @click="openSBPWidget">
        Оплатить в приложении банка
      </v-btn>

      <br> <br>
      <v-btn @click="close">
        Закрыть
      </v-btn>
      <br>
      <br>
    </v-sheet>
  </div>
</template>

<script lang="ts">
import {Component, Vue} from 'vue-facing-decorator';
import {closeWidget} from "@/utils";

@Component
export default class Success extends Vue {
  close = closeWidget

  isSBP(){
    return this.$route.query['url']?.includes('qr.nspk.ru') ? true : false
  }

  openSBPWidget(){

    // eslint-disable-next-line
    /* eslint-disable */
    //const SlideUpWidget = require('/public/js/slide-up-widget')

    //const slideUpWidget = new SlideUpWidget(window.localStorage, window.navigator) // eslint-disable-line

    const url = () => this.$route.query['url']

    window['sbpWidget'].showBankSelector(url())


  }

}
</script>
